import { Link } from "react-router-dom";
import galleryClassroom from "../assets/images/gallery-classroom.png";
import galleryWorkshop from "../assets/images/gallery-workshop.png";
import gallerySession from "../assets/images/gallery-session.png";
import { appName } from "../common";

const items = [
  {
    src: galleryClassroom,
    alt: "Students in blue, green, red, and yellow uniforms at wooden desks in a bright classroom with a teacher at the back.",
    title: "Our students",
    caption:
      "Focused learning in school settings — batches from primary through senior years.",
  },
  {
    src: galleryWorkshop,
    alt: "Instructor beside a laptop showing block-based coding and a small educational robot car.",
    title: "Workshops & demos",
    caption:
      "Hands-on robotics and visual programming — ideas turn into moving projects.",
  },
  {
    src: gallerySession,
    alt: "Students in uniform seated at desks listening to an instructor beside a laptop and robot kit.",
    title: "In the classroom",
    caption:
      "Interactive sessions where students see how code, electronics, and mechanics connect.",
  },
];

const Gallery = () => {
  return (
    <div className="page gallery-page">
      <section className="section gallery-intro">
        <h1>Gallery</h1>
        <p className="section-text">
          Snapshots from {appName} sessions in schools — robotics, coding, and STEM
          learning in real classrooms.
        </p>
      </section>

      <section className="gallery-strip" aria-hidden>
        <span>STEM</span>
        <span className="gallery-strip-dot">·</span>
        <span>Robotics</span>
        <span className="gallery-strip-dot">·</span>
        <span>Coding</span>
        <span className="gallery-strip-dot">·</span>
        <span>Hands-on</span>
      </section>

      <ul className="gallery-grid">
        {items.map((item) => (
          <li key={item.title} className="gallery-card">
            <div className="gallery-card-media">
              <img src={item.src} alt={item.alt} loading="lazy" />
            </div>
            <div className="gallery-card-body">
              <h2>{item.title}</h2>
              <p>{item.caption}</p>
            </div>
          </li>
        ))}
      </ul>

      <section className="section gallery-cta">
        <p className="section-text">
          Want a workshop or school program? Reach out and we will plan something
          that fits your students.
        </p>
        <Link className="btn btn-outline" to="/contact">
          Contact us
        </Link>
      </section>
    </div>
  );
};

export default Gallery;
